import { removeEmptyActivities } from './removeEmptyActivities';

export { removeEmptyActivities };
